export enum InvoiceWithdrawalMethodEnum {
  paypal = 'dashboard.invoice.paypal',
  bank_transfer = 'dashboard.invoice.bank_transfer',
}
